import { AnomalyTrackingNotificationMetaDataDTO } from "src/models/tna/tna-anomalies/anomaly-tracking-notification-meta-data-dto";
import { AnomalyTrackingNotificationMetaDataSTO } from "src/models/tna/tna-anomalies/anomaly-tracking-notification-meta-data-sto";
import { BaseApiService } from "../base/base-api.service";

export class AnomalyTrackingNotificationMetaData extends BaseApiService<
  AnomalyTrackingNotificationMetaDataDTO,
  AnomalyTrackingNotificationMetaDataSTO
> {
  constructor() {
    super({
      servicePath: "/Anomaly",
      loadItemsPath: "/GetAnomalyTrackingNotificationMetaData",
      saveItemsPath: "/SaveAnomalyTrackingNotificationMetaData",
    });
  }
}
